// @ts-nocheck
import { LensGroupInfo } from "../../lens-details/models/LensGroupInfo";
import { VendorDataCollection } from "../../../vendor-data/models";
import { type GetLensV2Query } from "../../api/query";
import { BaseModel } from "../../../core/models";
import { RangeModifierOperations } from "../../../connections/models/RangeModifierOperations";

export const LensGroupInfoService = {
    createFromConnection({
        group: { id, name, totalNumLenses },
        priority,
        vendorData,
        schedule,
    }: GetLensV2Query["getLensV2"]["connections"][0]) {
        return BaseModel.createInstance(LensGroupInfo, {
            groupId: id,
            name,
            numberOfLenses: totalNumLenses,
            priority,
            vendorData: new VendorDataCollection(vendorData),
            scheduleRange: RangeModifierOperations.fromSchedule(schedule),
        });
    },
};
